import React from 'react';

import './style.scss';

interface propsInterface {
  children: React.ReactNode;
  className?: string;
  border?: boolean;
  type?: 'default' | 'type-1';
  style?: React.CSSProperties;
}

const Wrapper = ({ children, className, border, style, type = 'default' }: propsInterface) => {
  let classNames = `v-wrapper v-wrapper__${type}`;
  classNames = className ? `${classNames} ${className}` : classNames;
  classNames = border ? `${classNames} v-wrapper__border` : classNames;

  return (
    <div className={classNames} style={style}>
      {children}
    </div>
  );
}

export default Wrapper;
